<section class="!mt-8" aria-labelledby="convocations-row-heading">
    <div class="!mb-4 !flex !flex-wrap !items-end !justify-between !gap-3">
        <div class="!flex !items-center !gap-2 justify-between w-full">
            <div class="!flex !items-center !gap-2">
                <i class="bi bi-calendar-check !text-xl !mb-0 !text-strong" aria-hidden="true"></i>
                <div> 

                    <h2
                    id="convocations-row-heading"
                    class="!text-xl !font-bold !tracking-tight !mb-0 !text-strong"
                    >
                    {{ heading }}
                </h2>
            </div>
            </div>
            <button
                *ngIf="showCreateButton"
                type="button"
                class="btn btn-primary btn-sm d-inline-flex align-items-center"
                (click)="openCreate.emit()"
            >
                <i class="bi bi-plus-lg me-1" aria-hidden="true"></i>
                Nuova convocazione
            </button>
        </div>
    </div>

    <div class="relative -mx-1">
        <ng-container *ngIf="!loading && convocations.length > 0">
        <button
            type="button"
            class="convocations-row-scroll-btn !absolute !left-1 !top-1/2 !z-10 !-translate-y-1/2 !flex !h-9 !w-9 !items-center !justify-center !rounded-full !border !border-border !bg-primary !text-base !leading-none !text-strong !shadow-md hover:!bg-secondary disabled:!cursor-not-allowed disabled:!hidden"
            [disabled]="!canScrollLeft"
            (click)="scrollList('left')"
            aria-label="Scorri le convocazioni a sinistra"
        >
            <i class="bi bi-chevron-left" aria-hidden="true"></i>
        </button>
        <button
            type="button"
            class="convocations-row-scroll-btn !absolute !right-1 !top-1/2 !z-10 !-translate-y-1/2 !flex !h-9 !w-9 !items-center !justify-center !rounded-full !border !border-border !bg-primary !text-base !leading-none !text-strong !shadow-md hover:!bg-secondary disabled:!cursor-not-allowed disabled:!hidden"
            [disabled]="!canScrollRight"
            (click)="scrollList('right')"
            aria-label="Scorri le convocazioni a destra"
        >
            <i class="bi bi-chevron-right" aria-hidden="true"></i>
        </button>
        </ng-container>
        <p *ngIf="!loading && convocations.length === 0" class="!mb-0 !text-sm !text-subtle">
            {{ emptyMessage }}
        </p>
        <div
            *ngIf="loading"
            class="convocations-row-skeleton -mx-1"
            role="status"
            aria-label="Caricamento convocazioni"
        >
            <div
                *ngFor="let _ of skeletonCardPlaceholders"
                class="convocations-row-skeleton__card !flex !flex-col !gap-3"
            >
                <div class="!flex !items-start !justify-between !gap-2">
                    <div class="mister-sk !h-5 !flex-1 !max-w-[85%]"></div>
                    <div class="mister-sk !h-5 !w-14 !shrink-0 !rounded-full"></div>
                </div>
                <div class="mister-sk !h-3 !max-w-[10rem] !w-full"></div>
                <div class="!mt-1 !space-y-2">
                    <div class="mister-sk !h-4 !w-full"></div>
                    <div class="mister-sk !h-4 !w-[90%]"></div>
                </div>
                <div class="!mt-auto !flex !gap-2 !border-t !border-border !pt-3">
                    <div class="mister-sk !h-4 !w-24"></div>
                    <div class="mister-sk !ml-auto !h-6 !w-16 !rounded-full"></div>
                </div>
            </div>
        </div>
        <div
            #convocationsScrollList
            *ngIf="!loading && convocations.length > 0"
            class="!flex !gap-4 !overflow-x-auto !overflow-y-visible !pb-2 !pt-1 !scroll-smooth !snap-x !snap-mandatory [scrollbar-gutter:stable]"
            role="list"
            (scroll)="updateScrollState()"
        >
        <article
            *ngFor="let c of convocations; trackBy: trackById"
            role="listitem"
            [routerLink]="detailRouteBase.concat(c.id)"
            tabindex="0"
            [attr.aria-labelledby]="'convocation-card-title-' + c.id"
            class="snap-start !shrink-0 !w-[min(100%,18rem)] sm:!w-72 !flex !flex-col !rounded-2xl !border !border-border !bg-white !p-4 !shadow-sm !ring-1 !ring-black/[0.02] flex items-start justify-between !cursor-pointer !no-underline !text-inherit transition-shadow duration-200 hover:!border-zinc-300 hover:!shadow-md focus-visible:!outline-none focus-visible:!ring-2 focus-visible:!ring-sky-500/35 focus-visible:!ring-offset-2"
        >
            <div class="!flex !items-start !justify-between !gap-2">
                <h3
                    [id]="'convocation-card-title-' + c.id"
                    class="!min-w-0 !flex-1 !text-base !font-semibold !leading-snug !mb-0 !text-strong !line-clamp-2"
                >
                    {{ c.title }}
                </h3>
                <span
                    class="!inline-flex !shrink-0 !items-center !rounded-full !px-2 !py-0.5 !text-xs !font-medium !ring-1 !ring-inset"
                    [ngClass]="statusClass(c.status)"
                >
                    {{ c.status }}
                </span>
            </div>

            <p *ngIf="c.categoryName" class="!mt-1 !text-xs !font-medium !mb-0 !text-subtle">
                {{ c.categoryName }}
            </p>

            <dl class="!mt-3 !space-y-2 !mb-0 !text-sm !text-subtle">
                <div class="!flex !gap-2">
                    <dt class="!sr-only">Data</dt>
                    <dd class="!flex !min-w-0 !items-start !gap-1.5 !mb-0 !text-strong">
                        <i class="bi bi-clock !mt-0.5 !shrink-0 !mb-0 !text-subtle" aria-hidden="true"></i>
                        <span class="!mb-0">{{ c.date | date : 'EEEE d MMMM y' : '' : 'it' }}, ore {{ c.date | date : 'HH:mm' : '' : 'it' }}</span>
                    </dd>
                </div>
                <div class="!flex !gap-2">
                    <dt class="!sr-only">Luogo</dt>
                    <dd class="!flex !min-w-0 !items-start !gap-1.5 !mb-0">
                        <i class="bi bi-geo-alt !mt-0.5 !shrink-0 !mb-0" aria-hidden="true"></i>
                        <span class="!line-clamp-2">
                            <span class="!font-medium !text-strong">{{ c.location }}</span>
                            <span class="!block !text-xs !mb-0">{{ c.address }} — {{ c.city }} ({{ c.province }})</span>
                        </span>
                    </dd>
                </div>
            </dl>
            <div
                class="!mt-4 !flex !flex-wrap !items-center !gap-2 !border-t !border-border !pt-3 !text-xs w-full"
            >
                <div
                    *ngIf="showDraftActions && isDraft(c.status)"
                    class="!flex !w-full !items-center !gap-2"
                    (click)="$event.stopPropagation()"
                >
                    <span class="!text-xs !font-medium !text-subtle">Bozza:</span>
                    <button
                        type="button"
                        class="convocation-draft-btn convocation-draft-btn--approve"
                        [disabled]="isUpdating(c.id)"
                        (click)="onApproveDraft(c, $event)"
                        aria-label="Approva e pubblica convocazione"
                        title="Approva e pubblica"
                    >
                        <i class="bi bi-check-lg !mb-0" aria-hidden="true"></i>
                    </button>
                    <button
                        type="button"
                        class="convocation-draft-btn convocation-draft-btn--cancel"
                        [disabled]="isUpdating(c.id)"
                        (click)="onCancelDraft(c, $event)"
                        aria-label="Annulla convocazione"
                        title="Annulla"
                    >
                        <i class="bi bi-x-lg !mb-0" aria-hidden="true"></i>
                    </button>
                </div>

                <ng-container *ngIf="isLink(c.linkPosition); else plainPosition">
                    <a
                        [href]="c.linkPosition"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="!relative !z-[1] !inline-flex !items-center !gap-1 !font-medium !no-underline !text-sky-700 hover:!text-sky-900 hover:!underline"
                        (click)="$event.stopPropagation()"
                    >
                        <i class="bi bi-pin-map !mb-0" aria-hidden="true"></i>
                        Mappa / posizione
                    </a>
                </ng-container>
                <ng-template #plainPosition>
                    <span class="!inline-flex !items-center !gap-1 !text-subtle">
                        <i class="bi bi-pin-map !mb-0" aria-hidden="true"></i>
                        {{ c.linkPosition }}
                    </span>
                </ng-template>

                <span
                    *ngIf="c.invitedCount !== undefined && c.invitedCount > 0"
                    class="!ml-auto !inline-flex !items-center !gap-1 !rounded-full !bg-zinc-100 !px-2 !py-0.5 !font-medium !text-zinc-700"
                >
                    <i class="bi bi-people !mb-0" aria-hidden="true"></i>
                    {{ c.invitedCount }}
                </span>
            </div>
        </article>
        </div>
    </div>
</section>
